﻿import React from 'react';
import { useTranslation } from 'react-i18next';
import Select_With_Label from '@Elements/FormElements/Select_With_Label';
import Content_Container from '@Elements/Content_Container';
import { H2 } from '@Elements/Fonts';

import { generate_unique_id } from '@Util/Utils';

import { Profile_Filter_Props } from '@Util/Types';

export default function Profile_Filter(props: Profile_Filter_Props): JSX.Element {
    const [t] = useTranslation();

    return (
        <section className="Module">
            <header className="Module_Header">
                <H2>{t('Text.Filter')}</H2>
            </header>
            <Content_Container>
                <form>
                    <Select_With_Label
                        id={generate_unique_id()}
                        label={t('Label.DisplayMode')}
                        value={props.data_view}
                        error={false}
                        onChange={(e) => props.set_data_view(e.target.value)}
                        options={[
                            { value: "day", text: t('Label.Today') },
                            { value: "week", text: t('Label.ThisWeek') },
                            { value: "month", text: t('Label.ThisMonth') }
                        ]}
                    />
                </form>
            </Content_Container>
        </section>
    )
}